import { Component, Input } from '@angular/core';
import { SetComponentsService } from '../../../services/edit/set-components.service';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../../side-nav/sidenav-content';

@Component({
  selector: 'edit-row',
  templateUrl: './edit-row.component.html',
  styleUrls: ['./edit-row.component.scss'],
})
export class EditRowComponent extends SidenavContent {
  @Input() row: any;
  @Input() page: any;
  @Input() rowType: any;
  @Input() rowArray: any;
  @Input() compArray: any;
  @Input() basic = true;
  @Input() layout = false;

  temp: any;
  OneColumn: boolean;
  TwoColumns: boolean;
  ThreeColumns: boolean;
  FourColumns: boolean;
  panelOneOpenState = true;
  panelTwoOpenState = false;
  panelThreeOpenState = false;
  fileToUpload: File = null;

  private _template: any = [];

  constructor(
    private _editService: SetComponentsService,
    private _layoutService: LayoutService,
  ) {
    super(_layoutService);
  }

  submitRow(rowType, index) {
    this.getEditRow(rowType);
    this._editService.setRow('', rowType, this._template, this.row.component, '');
    this.closeNav();
  }

  getEditRow(rowType) {
    switch (rowType) {
      case 'col-1':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-350 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-2':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-21':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-2-1-2':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-2-1-3':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-2-2-1':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-2-3-1':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-3-1-1-2':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-3-1-2-1':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-3-2-1-1':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-31':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-42':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-421':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-51':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-200 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-632':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
        ];
        break;
      case 'col-842':
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
          {
            typeOf: 'edit',
            className: 'width-100 height-250 pointer',
            flushed: false,
          },
        ];
        break;
      default:
        // reset to 1 column to advoid leakage and prevent components[i] durability.
        this.rowType = 'col-1';
        this._template = [
          {
            typeOf: 'edit',
            className: 'width-100 height-350 pointer',
            flushed: false,
          },
        ];
    }
  }
}
